import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { BodyText, Gutter, Loader, Div } from '@gaiads/telia-react-component-library';

import { fetchAdminProperties, selectAdminPropertiesLoading, selectAllProperties } from '../../../store/adminProperties';
import { setNotification } from '../../../store/ui';
import { Loading } from '../../../utils/store';
import PropertyItem from './PropertyItem/PropertyItem';

interface PropertiesProps {
  readonly onReady: () => void;
}

export default function Properties({ onReady }: PropertiesProps) {
  const { t } = useTranslation('adminSettings');
  const dispatch = useDispatch();

  const properties = useSelector(selectAllProperties);
  const loading = useSelector(selectAdminPropertiesLoading);

  useEffect(() => {
    dispatch(fetchAdminProperties());
  }, [dispatch]);

  useEffect(() => {
    if (loading === Loading.FAILED) {
      dispatch(
        setNotification({
          text: t('properties.errors.fetch'),
          show: true,
          type: 'warning',
        }),
      );
    }
    if (loading === Loading.SUCCEEDED || loading === Loading.FAILED) {
      onReady();
    }
  }, [loading, dispatch, t, onReady]);

  if (loading === Loading.PENDING || loading === Loading.IDLE) {
    return (
      <Div alignTextToCenter padding={{ top: 'md' }}>
        <Loader size="md" />
      </Div>
    );
  }

  return (
    <>
      <BodyText margin={{ bottom: 'md' }}>{t('properties.description')}</BodyText>
      {properties.length === 0 && loading === Loading.SUCCEEDED && <BodyText color="gray500">{t('properties.noProperties')}</BodyText>}
      {properties.map(property => (
        <React.Fragment key={property.id}>
          <PropertyItem property={property} />
          <Gutter size="sm" />
        </React.Fragment>
      ))}
    </>
  );
}
